// copied from packages/ui/src/components/FlavorFinder/components/Footer/index.ts
export * from "./FlavorFinderFooter";
